import { apiGet, apiPost, apiPut, apiDelete } from './apiClient'

function sortItems(items = []) {
  return [...items].sort((a, b) => {
    const orderA = Number(a.sort_order ?? 999)
    const orderB = Number(b.sort_order ?? 999)
    if (orderA !== orderB) return orderA - orderB
    const createdA = a.created_at ? new Date(a.created_at).getTime() : 0
    const createdB = b.created_at ? new Date(b.created_at).getTime() : 0
    return createdA - createdB
  })
}

export async function fetchReviews() {
  const { data, error } = await apiGet('/api/reviews')
  if (error || !data) return []
  return sortItems(data)
}

export async function fetchAdminReviews() {
  const { data, error } = await apiGet('/api/reviews/admin', { auth: true })
  if (error || !data) return []
  return sortItems(data)
}

export async function createReview(payload) {
  return apiPost('/api/reviews', payload, { auth: true })
}

export async function updateReview(id, payload) {
  return apiPut(`/api/reviews/${encodeURIComponent(id)}`, payload, { auth: true })
}

export async function deleteReview(id) {
  const { error } = await apiDelete(`/api/reviews/${encodeURIComponent(id)}`, { auth: true })
  return { error }
}
